// extracted by mini-css-extract-plugin
export default {"FeaturedTrucks":"JhsNfHJdnDRCADwH1eRm"};